import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { evidenceReducer } from './state/data-access.reducer';
import { StoreModule } from '@ngrx/store';
import { EVIDENCE_STORE_KEY } from './state/data-access.state';
import { EvidenceDetailsEffects } from './state/data-access.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(EVIDENCE_STORE_KEY, evidenceReducer), EffectsModule.forFeature([EvidenceDetailsEffects])],
  declarations: [],
  exports: [],
})
export class IntrensicEvidenceManagementDataAccessModule {}
